import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationDetailsTpamsConstants } from "./create-application-details-tpams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../../app-controller.service";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { AppConfig } from "../../../../../app.config";
import { AlertType } from "../../../../../shared/models/alert";
import { TownplanningService } from "../../../../../shared/services/modules/townplanning.service";
import { mapTpApplicationTypeLimitToUiState, normalizeTpApplicationTypeLimit } from "../../../../../shared/utils/tp-application-type-limit.utils";
let CreateApplicationDetailsTpamsComponent = class CreateApplicationDetailsTpamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    townPlanningService;
    changeDetectorRefs;
    componentName = CreateApplicationDetailsTpamsConstants.COMPONENT_NAME;
    detailsForm;
    validationMessages = CreateApplicationDetailsTpamsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = CreateApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = CreateApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = CreateApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationDetailsTpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationDetailsTpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    acceptFormControlName = CreateApplicationDetailsTpamsConstants.ACCEPT_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    addApplicationTypeLabel = CreateApplicationDetailsTpamsConstants.ADD_APPLICATION_TYPE_LABEL;
    addZoneLabel = CreateApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = CreateApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = CreateApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    previousReferenceNumberLabel = CreateApplicationDetailsTpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationDetailsTpamsConstants.IS_RESUBMISSION_LABEL;
    verifyLabel = CreateApplicationDetailsTpamsConstants.VERIFY_LABEL;
    acceptFormControlLabel = CreateApplicationDetailsTpamsConstants.ACCEPT_LABEL;
    applicationTypes = [];
    zones = [];
    rezoneConfirmationControlName = CreateApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME;
    rezoneConfirmationLabel = CreateApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_LABEL;
    rezoneKeywordRezone = CreateApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONE;
    rezoneKeywordRezoning = CreateApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONING;
    isRezoning = false;
    rezoningChecked = false;
    applicationTypesControl;
    applicationTypeLimit = CreateApplicationDetailsTpamsConstants.UNLIMITED_APPLICATION_TYPE_LIMIT;
    applicationTypeLimitReachedWarningMessage = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_LIMIT_REACHED_WARNING_MESSAGE;
    applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, 0);
    verificationMessage = CreateApplicationDetailsTpamsConstants.RESUBMISSION_VERIFICATION_MESSAGE;
    titleLabelMessage = CreateApplicationDetailsTpamsConstants.RESUBMISSION_DISCLAIMER_TITLE;
    contentLabelMessage = CreateApplicationDetailsTpamsConstants.RESUBMISSION_DISCLAIMER_CONTENT;
    yesNoOptions = [];
    isResubmissionOptions = [];
    supportResubmissions = false;
    isResubmission = false;
    isVerified = false;
    showDetails = true;
    resubmissionDisclaimerTitle = "";
    resubmissionDisclaimerContent = "";
    acceptResubmissionDisclaimer = false;
    constructor(createApplicationService, aflaModuleStrategyService, appController, townPlanningService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.townPlanningService = townPlanningService;
        this.changeDetectorRefs = changeDetectorRefs;
        if (AppConfig.settings) {
            this.resubmissionDisclaimerTitle = AppConfig.settings.resubmissionDisclaimer.tp.title;
            this.resubmissionDisclaimerContent = AppConfig.settings.resubmissionDisclaimer.tp.content;
            if (this.resubmissionDisclaimerTitle === "") {
                this.resubmissionDisclaimerTitle = this.titleLabelMessage;
            }
            if (this.resubmissionDisclaimerContent === "") {
                this.resubmissionDisclaimerContent = this.contentLabelMessage;
            }
        }
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.zones = defaults.zoneOptions;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
                this.zones = this.aflaModuleStrategyService.lookups.get("zones");
            }
            else {
                this.getLookups();
            }
            this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
            this.isResubmissionOptions = [];
            this.isResubmissionOptions = [
                { code: SharedConstants.YES_NO_ENUM.Yes, value: SharedConstants.YES_NO_ENUM.Yes },
                { code: SharedConstants.YES_NO_ENUM.No, value: SharedConstants.YES_NO_ENUM.No }
            ];
            this.getMetadata();
        }
        this.initForm();
        this.loadApplicationTypeLimit();
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
        if (this.appController.moduleAllowResubmission) {
            this.supportResubmissions = true;
            this.showDetails = false;
        }
        else {
            this.supportResubmissions = false;
            this.showDetails = true;
        }
        if (this.detailsForm.get(this.isResubmissionFormControlName).value !== null) {
            const element = this.detailsForm.get(this.isResubmissionFormControlName).value;
            if (element === SharedConstants.YES_NO_ENUM.Yes) {
                this.isResubmission = true;
                this.showDetails = true;
                if (this.detailsForm.get("verified").value !== null && this.detailsForm.get("verified").value === true) {
                    this.isVerified = true;
                }
            }
            else {
                this.isResubmission = false;
                this.showDetails = true;
            }
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    loadMetadata(stepMeta) {
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType' or name eq 'Zoning')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === "Zoning") {
                    zones.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        zones.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.aflaModuleStrategyService.lookups.set("zones", zones);
        this.zones = zones;
        this.changeDetectorRefs.detectChanges();
    }
    getApplicationTypes() {
        return this.detailsForm.get("applicationTypes");
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    getZones() {
        return this.detailsForm.get("zones");
    }
    onBtnRemoveZoneClicked(i) {
        const controls = this.getZones();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddApplicationTypeClicked() {
        if (this.isApplicationTypeAddBlockedByLimit()) {
            return;
        }
        if (!this.canAddSelectionControl(this.getApplicationTypes(), this.applicationTypeFormControlName, this.applicationTypes, CreateApplicationDetailsTpamsConstants.ALL_APPLICATION_TYPES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addApplicationTypeControl();
        this.updateApplicationTypeLimitUiState();
    }
    shouldShowAddApplicationTypeButton() {
        return !this.applicationTypeLimitUiState.hideButtons && !this.applicationTypeLimitUiState.disableAdd;
    }
    onBtnAddZoneClicked() {
        if (!this.canAddSelectionControl(this.getZones(), this.zoneFormControlName, this.zones, CreateApplicationDetailsTpamsConstants.ALL_ZONES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addZoneControl();
    }
    onApplicationTypeSelected(index) {
        const duplicateSelectionFound = this.clearControlSelectionIfDuplicate(this.getApplicationTypes(), this.applicationTypeFormControlName, index, CreateApplicationDetailsTpamsConstants.DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE);
        if (duplicateSelectionFound) {
            this.updateApplicationTypeLimitUiState();
            this.syncRezoningStateWithSelection();
            return;
        }
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    onZoneSelected(index) {
        this.clearControlSelectionIfDuplicate(this.getZones(), this.zoneFormControlName, index, CreateApplicationDetailsTpamsConstants.DUPLICATE_ZONE_WARNING_MESSAGE);
    }
    onRezoningChecked(event) {
        const element = event.target.checked;
        this.rezoningChecked = element;
        const zonesControl = this.getZones();
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    addApplicationTypeControl() {
        const typeGroup = new FormGroup({
            type: new FormControl(null, [Validators.required])
        });
        this.getApplicationTypes().push(typeGroup);
    }
    addZoneControl() {
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        this.getZones().push(zoneGroup);
    }
    canAddSelectionControl(controls, controlName, availableOptions, warningMessage) {
        const selectedValues = this.getDistinctSelectedValues(controls, controlName);
        const allOptionsAlreadySelected = availableOptions.length > 0 && selectedValues.size >= availableOptions.length;
        if (allOptionsAlreadySelected) {
            this.appController.showMessage(warningMessage, AlertType.Warning);
            return false;
        }
        return true;
    }
    getDistinctSelectedValues(controls, controlName) {
        const selectedValues = new Set();
        controls.controls.forEach(control => {
            const selectedOption = control.get(controlName)?.value;
            if (selectedOption?.value) {
                selectedValues.add(selectedOption.value.toLowerCase());
            }
        });
        return selectedValues;
    }
    clearControlSelectionIfDuplicate(controls, controlName, selectedIndex, warningMessage) {
        const selectedControl = controls.at(selectedIndex);
        const selectedOption = selectedControl.get(controlName)?.value;
        if (!selectedOption?.value) {
            return false;
        }
        const selectedValue = selectedOption.value.toLowerCase();
        const duplicateSelectionExists = controls.controls.some((control, index) => {
            if (index === selectedIndex) {
                return false;
            }
            const currentValue = control.get(controlName)?.value?.value;
            return currentValue?.toLowerCase() === selectedValue;
        });
        if (!duplicateSelectionExists) {
            return false;
        }
        selectedControl.get(controlName).setValue(null);
        this.appController.showMessage(warningMessage, AlertType.Warning);
        return true;
    }
    syncRezoningStateWithSelection() {
        this.isRezoning = this.hasSelectedRezoningApplicationType();
        const zonesControl = this.getZones();
        if (!this.isRezoning) {
            this.rezoningChecked = false;
            zonesControl.clear();
            zonesControl.disable();
            return;
        }
        this.rezoningChecked = this.hasSelectedZoneValue() || zonesControl.enabled;
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.disable();
    }
    hasSelectedRezoningApplicationType() {
        const applicationTypesControls = this.getApplicationTypes();
        return applicationTypesControls.controls.some(control => {
            const selectedType = control.get(this.applicationTypeFormControlName)?.value;
            return this.isRezoningApplicationType(selectedType);
        });
    }
    isRezoningApplicationType(applicationType) {
        if (!applicationType?.value) {
            return false;
        }
        const typeValue = applicationType.value.toLowerCase();
        return typeValue.includes(this.rezoneKeywordRezone) || typeValue.includes(this.rezoneKeywordRezoning);
    }
    hasSelectedZoneValue() {
        const zonesControl = this.getZones();
        return zonesControl.controls.some(control => {
            const selectedZone = control.get(this.zoneFormControlName)?.value;
            return !!selectedZone?.value;
        });
    }
    loadApplicationTypeLimit() {
        const moduleId = this.getCurrentModuleIdForLimit();
        this.townPlanningService
            .getApplicationTypeLimitObservable(moduleId)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe((applicationTypeLimit) => {
            this.applicationTypeLimit = normalizeTpApplicationTypeLimit(applicationTypeLimit);
            this.updateApplicationTypeLimitUiState();
            this.changeDetectorRefs.detectChanges();
        });
    }
    isApplicationTypeAddBlockedByLimit() {
        this.updateApplicationTypeLimitUiState();
        if (!this.applicationTypeLimitUiState.disableAdd) {
            return false;
        }
        this.appController.showMessage(this.applicationTypeLimitReachedWarningMessage, AlertType.Warning);
        return true;
    }
    ensureApplicationTypeDropdownIsVisible() {
        const applicationTypesControl = this.getApplicationTypes();
        if (applicationTypesControl.length > 0) {
            return;
        }
        this.addApplicationTypeControl();
    }
    updateApplicationTypeLimitUiState() {
        if (!this.detailsForm) {
            return;
        }
        const currentVisibleControlCount = this.getApplicationTypeControlCountForLimit();
        this.applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, currentVisibleControlCount);
        if (this.applicationTypeLimitUiState.fullWidthDropdown) {
            this.ensureApplicationTypeDropdownIsVisible();
        }
    }
    getCurrentModuleIdForLimit() {
        const createModuleId = Number(this.createApplicationService.moduleID);
        if (Number.isFinite(createModuleId) && createModuleId > 0) {
            return createModuleId;
        }
        const selectedModuleId = Number(this.appController.selectedModuleID);
        if (Number.isFinite(selectedModuleId) && selectedModuleId > 0) {
            return selectedModuleId;
        }
        return 0;
    }
    getApplicationTypeControlCountForLimit() {
        return this.getApplicationTypes().length;
    }
    resetVerification() {
        this.aflaModuleStrategyService.previousApplication = null;
        this.isVerified = false;
        this.showDetails = false;
        this.acceptResubmissionDisclaimer = false;
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        this.detailsForm.get(this.descriptionFormControlName).reset();
        this.detailsForm.get("verified").setValue(false);
        if (this.isResubmission) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(previousReferenceNumber);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
        }
        else {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
        }
        this.createApplicationService.propertyData = null;
        this.aflaModuleStrategyService.form.get("propertiesForm").reset();
        this.aflaModuleStrategyService.form.get("applicantForm").reset();
        this.aflaModuleStrategyService.form.get("noteForm").reset();
    }
    onIsResubmissionChanged(event) {
        const element = event.target?.value;
        this.aflaModuleStrategyService.previousApplication = null;
        this.aflaModuleStrategyService.resetForm();
        this.aflaModuleStrategyService.form.get("propertiesForm").get("properties").clear();
        this.syncRezoningStateWithSelection();
        if (element === SharedConstants.YES_NO_ENUM.Yes) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.Yes);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValidators([Validators.required]);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).enable();
            this.detailsForm.get("acceptDisclaimer").setValidators([Validators.required]);
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isResubmission = true;
            this.isVerified = false;
            this.showDetails = false;
            this.acceptResubmissionDisclaimer = false;
        }
        else {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(SharedConstants.YES_NO_ENUM.No);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).clearValidators();
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(null);
            this.detailsForm.get(this.previousReferenceNumberFormControlName).disable();
            this.detailsForm.get("acceptDisclaimer").clearValidators();
            this.detailsForm.get("acceptDisclaimer").setValue(null);
            this.isResubmission = false;
            this.isVerified = false;
            this.showDetails = true;
            this.acceptResubmissionDisclaimer = false;
        }
        this.detailsForm.get("verified").setValue(this.isVerified);
        this.detailsForm.get("acceptDisclaimer").updateValueAndValidity();
        this.detailsForm.get(this.previousReferenceNumberFormControlName).updateValueAndValidity();
        this.detailsForm.updateValueAndValidity();
        this.updateApplicationTypeLimitUiState();
        this.changeDetectorRefs.detectChanges();
    }
    onVerifyReferenceNumberClicked() {
        const previousReferenceNumber = this.detailsForm.get(this.previousReferenceNumberFormControlName).value;
        if (previousReferenceNumber !== null || previousReferenceNumber !== "") {
            const params = {
                previousReferenceNumber,
                isResubmission: this.isResubmission,
                moduleId: this.appController.selectedModuleID
            };
            this.townPlanningService.verifyResubmissionReferenceNumberObservable(params).subscribe({
                next: response => {
                    this.onVerifyComplete(response);
                },
                error: err => {
                    this.onVerifyError(err);
                }
            });
        }
    }
    onVerifyComplete(response) {
        if (response !== undefined && response !== null) {
            this.showDetails = true;
            this.aflaModuleStrategyService.previousApplication = response;
            this.getCompleteApplication();
            this.appController.showMessage(this.verificationMessage, AlertType.Success);
            this.isVerified = true;
            this.detailsForm.get("verified").setValue(this.isVerified);
            this.changeDetectorRefs.detectChanges();
        }
        else {
            this.appController.showMessage("Invalid previous application reference number provided", AlertType.Error);
        }
    }
    onVerifyError(err) {
        this.appController.handleServerErrorMessage(this.componentName, err, CRUDOperation.Selecting);
        this.showDetails = false;
        this.isVerified = false;
        this.detailsForm.get("verified").setValue(this.isVerified);
        this.changeDetectorRefs.detectChanges();
    }
    onGetApplicationDetailsCompleted(response) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(response.description);
        this.detailsForm.get(this.amendmentSchemeNumberFormControlName).setValue(response.amendmentSchemeNumber);
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        const persistedApplicationTypes = this.getPersistedApplicationTypes(response.applicationTypes);
        persistedApplicationTypes.forEach(applicationType => {
            const appType = this.findApplicationTypeLookupOption(applicationType.applicationType);
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl(appType, [Validators.required])
            });
            typesControl.push(typeGroup);
        });
        this.updateApplicationTypeLimitUiState();
        const zonesControl = this.getZones();
        zonesControl.clear();
        response.applicationZonings.forEach(applicationZoning => {
            let zone = null;
            this.zones.forEach(item => {
                if (item.value === applicationZoning.zoning) {
                    zone = item;
                }
            });
            const zoneGroup = new FormGroup({
                id: new FormControl(applicationZoning.id),
                applicationId: new FormControl(applicationZoning.applicationId),
                applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                zone: new FormControl(zone, [Validators.required])
            });
            zonesControl.push(zoneGroup);
        });
        this.syncRezoningStateWithSelection();
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    getPersistedApplicationTypes(applicationTypes) {
        if (!Array.isArray(applicationTypes) || applicationTypes.length === 0) {
            return [];
        }
        return applicationTypes.filter((applicationType) => this.hasNonEmptyText(applicationType?.applicationType));
    }
    findApplicationTypeLookupOption(applicationTypeValue) {
        const matchingLookup = this.applicationTypes.find((lookupItem) => lookupItem.value === applicationTypeValue);
        return matchingLookup ?? null;
    }
    hasNonEmptyText(value) {
        if (typeof value !== "string") {
            return false;
        }
        return value.trim().length > 0;
    }
    getCompleteApplication() {
        const params = {
            $filter: `jobId eq ${this.aflaModuleStrategyService.previousApplication.jobId} and moduleId eq ${this.appController.selectedModuleID}`,
            $expand: `properties($expand=zonings,owners($expand=groups)),applicant($expand=groups),applicantAgent($expand=groups),applicationTypes,applicationZonings`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const cleanedResult = this.cleanPreviousApplicationData(returnValue.value[0]);
            const result = cleanedResult;
            this.aflaModuleStrategyService.previousApplication = result;
            this.onGetApplicationDetailsCompleted(result);
            // set applicant form data
            if (result.applicant[0] !== null) {
                this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(result.applicant[0]);
            }
            // set applicantAgent form data
            this.aflaModuleStrategyService.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").setValue(!result.applicantAgentNa);
            if (result.applicantAgent[0] !== null && result.applicantAgent.length !== 0) {
                this.aflaModuleStrategyService.form.get("applicantForm").get("applicantAgentRecipient").setValue(result.applicantAgent[0]);
                this.aflaModuleStrategyService.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").setValue(true);
            }
            // set location
            this.createApplicationService.propertyData = result.properties[0];
        });
    }
    cleanPreviousApplicationData(application) {
        const app = {};
        if (application) {
            app.applicantAgentNa = application.applicantAgentNa;
            app.amendmentSchemeNumber = application.amendmentSchemeNumber;
            app.decision = application.decision;
            app.applicantAgentNa = application.applicantAgentNa;
            app.description = application.description;
            app.shape = application.shape;
            app.wkid = application.wkid;
            app.moduleId = application.moduleId;
            app.applicationTypes = application.applicationTypes,
                app.applicationZonings = application.applicationZonings,
                app.daysUntilExpired = application.daysUntilExpired,
                app.townplannerId = application.townplannerId;
        }
        if (application.applicationTypes) {
            let applicationTypes = {};
            applicationTypes = [];
            application.applicationTypes.forEach(a => {
                const applicationType = {};
                applicationType.applicationType = a.applicationType;
                applicationTypes.push(applicationType);
            });
            app.applicationTypes = applicationTypes;
        }
        if (application.applicationZonings) {
            let zonings = {};
            zonings = [];
            application.applicationZonings.forEach(z => {
                const zone = {};
                zone.zoning = z.zoning;
                zonings.push(zone);
            });
            app.applicationZonings = zonings;
        }
        if (application.properties) {
            let properties = {};
            properties = [];
            application.properties.forEach(p => {
                const property = {};
                property.id = 0;
                property.erfNumber = p.erfNumber;
                property.allotment = p.allotment;
                property.farmNumber = p.farmNumber;
                property.sgCode = p.sgCode;
                property.address = p.address;
                property.erfSize = p.erfSize;
                property.titleDeed = p.titleDeed;
                property.subdivision = p.subdivision;
                property.shape = p.shape;
                property.wkid = p.wkid;
                property.isDummy = p.isDummy;
                property.updateGeometry = p.updateGeometry;
                property.buildingFloorArea = p.buildingFloorArea,
                    property.buildingUse = p.buildingUse,
                    property.isDummy = p.isDummy,
                    property.shape = p.shape,
                    property.updateGeometry = p.updateGeometry,
                    property.wkid = p.wkid;
                if (p.owners) {
                    let owners = {};
                    owners = [];
                    p.owners.forEach(o => {
                        const owner = {};
                        owner.clientVatNumber = o.clientVatNumber;
                        owner.setRecipient = o.setRecipient;
                        owner.fullName = o.fullName;
                        owner.id = 0;
                        owner.moduleId = o.moduleId;
                        owner.name = o.name;
                        owner.surname = o.surname;
                        owner.telephone = o.telephone;
                        owner.email = o.email;
                        owner.defaultCommunicationMethod = o.defaultCommunicationMethod;
                        owner.postalAddress = o.postalAddress;
                        owner.designation = o.designation;
                        owner.organisation = o.organisation;
                        owner.streetAddress = o.streetAddress;
                        owner.homePhone = o.homePhone;
                        owner.idNumber = o.idNumber;
                        owner.organisationRegistrationNumber = o.organisationRegistrationNumber;
                        owner.representative = o.representative;
                        owner.fax = o.fax;
                        owner.maritalStatus = o.maritalStatus;
                        owner.relativesFullName = o.relativesFullName;
                        owner.relativesContactNumber = o.relativesContactNumber;
                        owner.relativesAddress = o.relativesAddress;
                        owner.employmentStatus = o.employmentStatus;
                        owner.employersName = o.employersName;
                        owner.employersContactNumber = o.employersContactNumber;
                        owner.employersAddress = o.employersAddress;
                        owner.cellphone = o.cellphone;
                        owner.streetSuburb = o.streetSuburb;
                        owner.streetCity = o.streetCity;
                        owner.streetProvince = o.streetProvince;
                        owner.streetCode = o.streetCode;
                        owner.postalSuburb = o.postalSuburb;
                        owner.postalCity = o.postalCity;
                        owner.postalProvince = o.postalProvince;
                        owner.postalCode = o.postalCode;
                        owner.postalCountry = o.postalCountry;
                        owner.streetCountry = o.streetCountry;
                        owner.professionalBody = o.professionalBody;
                        owner.professionalBodyRegNum = o.professionalBodyRegNum;
                        owner.consolidatedGroup = o.consolidatedGroup;
                        owner.emailField = o.emailField;
                        let groups = {};
                        groups = [];
                        o.groups.forEach(g => {
                            const group = {};
                            group.groupName = g.groupName;
                            group.groupType = g.groupType;
                            groups.push(group);
                        });
                        owner.groups = groups;
                        /*     owner.groupsStringArray?: string[]; */
                        owners.push(owner);
                    });
                    property.owners = owners;
                }
                if (p.zonings) {
                    let zonings = {};
                    zonings = [];
                    p.zonings.forEach(z => {
                        const zone = {};
                        zone.zoning = z.zoning;
                        zonings.push(zone);
                    });
                    property.zonings = zonings;
                }
                properties.push(property);
            });
            app.properties = properties;
        }
        if (application.applicant) {
            let applicants = {};
            applicants = [];
            application.applicant.forEach(a => {
                const applicant = {};
                applicant.clientVatNumber = a.clientVatNumber;
                applicant.setRecipient = a.setRecipient;
                applicant.fullName = a.fullName;
                applicant.id = 0;
                applicant.passportNumber = a.passportNumber;
                applicant.gender = a.gender;
                applicant.moduleId = a.moduleId;
                applicant.name = a.name;
                applicant.surname = a.surname;
                applicant.telephone = a.telephone;
                applicant.email = a.email;
                applicant.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicant.postalAddress = a.postalAddress;
                applicant.designation = a.designation;
                applicant.organisation = a.organisation;
                applicant.streetAddress = a.streetAddress;
                applicant.homePhone = a.homePhone;
                applicant.idNumber = a.idNumber;
                applicant.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicant.representative = a.representative;
                applicant.fax = a.fax;
                applicant.maritalStatus = a.maritalStatus;
                applicant.relativesFullName = a.relativesFullName;
                applicant.relativesContactNumber = a.relativesContactNumber;
                applicant.relativesAddress = a.relativesAddress;
                applicant.employmentStatus = a.employmentStatus;
                applicant.employersName = a.employersName;
                applicant.employersContactNumber = a.employersContactNumber;
                applicant.employersAddress = a.employersAddress;
                applicant.cellphone = a.cellphone;
                applicant.streetSuburb = a.streetSuburb;
                applicant.streetCity = a.streetCity;
                applicant.streetProvince = a.streetProvince;
                applicant.streetCode = a.streetCode;
                applicant.postalSuburb = a.postalSuburb;
                applicant.postalCity = a.postalCity;
                applicant.postalProvince = a.postalProvince;
                applicant.postalCode = a.postalCode;
                applicant.postalCountry = a.postalCountry;
                applicant.streetCountry = a.streetCountry;
                applicant.professionalBody = a.professionalBody;
                applicant.professionalBodyRegNum = a.professionalBodyRegNum;
                applicant.consolidatedGroup = a.consolidatedGroup;
                applicant.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicant.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                applicants.push(applicant);
            });
            app.applicant = applicants;
        }
        if (application.applicantAgent) {
            let applicantAgents = {};
            applicantAgents = [];
            application.applicantAgent.forEach(a => {
                const applicantAgent = {};
                applicantAgent.clientVatNumber = a.clientVatNumber;
                applicantAgent.setRecipient = a.setRecipient;
                applicantAgent.fullName = a.fullName;
                applicantAgent.id = 0;
                applicantAgent.moduleId = a.moduleId;
                applicantAgent.name = a.name;
                applicantAgent.surname = a.surname;
                applicantAgent.telephone = a.telephone;
                applicantAgent.email = a.email;
                applicantAgent.passportNumber = a.passportNumber;
                applicantAgent.gender = a.gender;
                applicantAgent.defaultCommunicationMethod = a.defaultCommunicationMethod;
                applicantAgent.postalAddress = a.postalAddress;
                applicantAgent.designation = a.designation;
                applicantAgent.organisation = a.organisation;
                applicantAgent.streetAddress = a.streetAddress;
                applicantAgent.homePhone = a.homePhone;
                applicantAgent.idNumber = a.idNumber;
                applicantAgent.organisationRegistrationNumber = a.organisationRegistrationNumber;
                applicantAgent.representative = a.representative;
                applicantAgent.fax = a.fax;
                applicantAgent.maritalStatus = a.maritalStatus;
                applicantAgent.relativesFullName = a.relativesFullName;
                applicantAgent.relativesContactNumber = a.relativesContactNumber;
                applicantAgent.relativesAddress = a.relativesAddress;
                applicantAgent.employmentStatus = a.employmentStatus;
                applicantAgent.employersName = a.employersName;
                applicantAgent.employersContactNumber = a.employersContactNumber;
                applicantAgent.employersAddress = a.employersAddress;
                applicantAgent.cellphone = a.cellphone;
                applicantAgent.streetSuburb = a.streetSuburb;
                applicantAgent.streetCity = a.streetCity;
                applicantAgent.streetProvince = a.streetProvince;
                applicantAgent.streetCode = a.streetCode;
                applicantAgent.postalSuburb = a.postalSuburb;
                applicantAgent.postalCity = a.postalCity;
                applicantAgent.postalProvince = a.postalProvince;
                applicantAgent.postalCode = a.postalCode;
                applicantAgent.postalCountry = a.postalCountry;
                applicantAgent.streetCountry = a.streetCountry;
                applicantAgent.professionalBody = a.professionalBody;
                applicantAgent.professionalBodyRegNum = a.professionalBodyRegNum;
                applicantAgent.consolidatedGroup = a.consolidatedGroup;
                applicantAgent.emailField = a.emailField;
                let groups = {};
                groups = [];
                a.groups.forEach(g => {
                    const group = {};
                    group.groupName = g.groupName;
                    group.groupType = g.groupType;
                    groups.push(group);
                });
                applicantAgent.groups = groups;
                /*      owner.groupsStringArray?: string[]; */
                applicantAgents.push(applicantAgent);
            });
            app.applicantAgent = applicantAgents;
        }
        else {
            app.applicantAgentNa = true;
        }
        return app;
    }
    onToggleAccept(event) {
        if (!this.detailsForm.get("verified").value) {
            this.appController.showMessage("Please validate an application before accepting disclaimer", AlertType.Warning);
            this.detailsForm.get("acceptDisclaimer").setValue(false);
            return;
        }
        const accept = event.target.checked;
        this.detailsForm.get("acceptDisclaimer").setValue(accept);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: TownplanningService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsTpamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsTpamsComponent);
export { CreateApplicationDetailsTpamsComponent };
